import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-quote',
  templateUrl: './health-quote.component.html',
  styleUrls: ['./health-quote.component.scss']
})
export class HealthQuoteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
